/* projects/wtaf/src/app/features/widgets/scheduler-performance-widget/scheduler-performance-widget.component.css */
.widget-subtitle {
  font-size: 12px;
  color: #6c757d;
}
.counter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.counter-pill {
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}
.counter-total {
  background: #f1f3f5;
  border-color: #d9dee3;
  color: #495057;
}
.counter-running {
  background: #eaf4ff;
  border-color: #a5cffd;
  color: #1f78d1;
}
.counter-completed {
  background: #eaf8f0;
  border-color: #b9e7ca;
  color: #1aaa55;
}
.counter-incomplete {
  background: #fff2e8;
  border-color: #f8cfaf;
  color: #d96b1d;
}
.counter-terminated {
  background: #fff4e6;
  border-color: #ffd59e;
  color: #d9822b;
}
.counter-skipped {
  background: #f2f0ff;
  border-color: #cdc7ff;
  color: #5b54c7;
}
.result-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.result-pill {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}
.pass-pill {
  background: #eaf8f0;
  border-color: #b9e7ca;
  color: #1aaa55;
}
.fail-pill {
  background: #fff1f0;
  border-color: #ffc9c2;
  color: #db3b21;
}
.skip-pill {
  background: #f2f0ff;
  border-color: #cdc7ff;
  color: #5b54c7;
}
.statusBtn {
  min-width: 110px;
  font-size: 12px;
}
.failedBtn {
  border: 1px solid #db3b21;
  color: #db3b21;
}
.passedBtn {
  border: 1px solid #1aaa55;
  color: #1aaa55;
}
.incompleteBtn {
  border: 1px solid #f2994a;
  color: #f2994a;
}
.runningBtn {
  border: 1px solid #1f78d1;
  color: #1f78d1;
}
.unknownBtn {
  border: 1px solid #6c757d;
  color: #6c757d;
}
.no-record {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
}
.error-msg {
  color: #db3b21;
  font-size: 13px;
  font-weight: 500;
}
.see-more-link {
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=scheduler-performance-widget.component.css.map */
